<div class="d-flex flex-column" style="max-height: 100%;">
    <div class="pb-2 d-flex flex-md-row flex-column">
        <div>
            <app-assignments-filter-display [filterModelSubject]="assignmentsStateService.pastAssignmentsFilterSubject">
            </app-assignments-filter-display>
        </div>
        <div class="flex-grow-1"></div>
    </div>
    <div class="flex-grow-1 overflow-y-auto">
        <app-assignments-list [assignmentSubject]="assignmentsStateService.pastAssignmentsSubject" [displayFinanceInformation]="true"
            [eventType]="assignmentEventType.RouteToPastDetails">
        </app-assignments-list>
    </div>
</div>